export default {
	name: 'TicketDetailElement',
	data() {
		return {};
	},

	props: {
		icon: String,
		label: String,
		vertical: Boolean,
	},

	computed: {},

	created() {},

	methods: {},
};
